import {LanguageCodeList} from '@gongxigames/framework/core';

export const RegulatedJackpotLocales: Partial<Record<LanguageCodeList, LanguageCodeList>> = {
    en: LanguageCodeList['re-en']
};
